import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { MomentoPantalon } from './components/MomentoPantalon';
import { WhyFailed } from './components/WhyFailed';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { ChapterPreview } from './components/ChapterPreview';
import { HowItWorks } from './components/HowItWorks';
import { ForWhom } from './components/ForWhom';
import { Believability } from './components/Believability';
import { FAQ } from './components/FAQ';
import { OfferBlock } from './components/OfferBlock';
import { ClosingSection } from './components/ClosingSection';
import { LegalFooter } from './components/LegalFooter';
export function App() {
  return <div className="min-h-screen" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Hero data-id="element-2" />
      <MomentoPantalon data-id="element-3" />
      <WhyFailed data-id="element-4" />
      <UniqueMechanism data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <ChapterPreview data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <ForWhom data-id="element-9" />
      <Believability data-id="element-10" />
      <FAQ data-id="element-11" />
      <OfferBlock data-id="element-12" />
      <ClosingSection data-id="element-13" />
      <LegalFooter data-id="element-14" />
    </div>;
}